<template>
  <div style="height: 100%;" v-if="isLoadConfig">
    <grid :showChange="true" :changeNamespace="namespace" ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="topNoSelectMenus">
        <grid-menu-a
          class="btn btn-hollow-dark"
          @menu-click="back"
          name="返回"
        >
        </grid-menu-a>
      </template>
      <template slot="headerColumns">
        <li class="main-table-cell">
          <div class="main-table-cell-wrap">
            <span class="main-table-txt">查看数据</span>
          </div>
        </li>
      </template>
      <template slot="bodyColumns" slot-scope="props">
        <li class="main-table-cell">
          <div class="main-table-cell-wrap">
            <span class="main-table-txt">
              <a @click="showDetail(props.row)" class="link-normal">查看数据</a>
            </span>
          </div>
        </li>
      </template>
    </grid>
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form" :append-to-body="true"
               @close="handleDialogClose" width="480px">
      <div slot="title" class="popup-head">
        <span class="popup-tit">删除前快照</span>
      </div>
      <el-scrollbar class="whaty-scroll">
        <div>
          <div class="whaty-common-form">
            <div class="popup-body">
              <div class="content content-complex" style="overflow-y:auto; overflow-x:auto;">
                  <div class="edit-form">
                    <div class="component-form single-column">
                      <ul class="clearfix">
                        <template v-for="(value, key) in detailData">
                          <li class="form-row form-pretitle dvs-1 form-plain-text vertical-top">
                            <div class="form-title text-left"><span>{{ key }}</span></div>
                            <div class="form-con form-error">
                              <div class="text-wrap">{{ value }}</div>
                            </div>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
  import Grid from '../grid/grid'
  import GridMenuA from '../grid-menu/grid-menu-a.vue'
  import util from '@/libs/util'
  export default {
    name: 'show-delete-record',
    components: {
      Grid,
      GridMenuA
    },
    data() {
      return {
        visible: false,
        detailData: null,
        namespace: this.$route.query.namespace,
        isLoadConfig: true
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.isLoadConfig = false
      this.$nextTick(() => (this.isLoadConfig = true))
      next()
    },
    computed: {
      gridConfigUrl: function () {
        return this.$route.meta.url
      }
    },
    methods: {
      showDetail: function (row) {
        let data = JSON.parse(row.statusData).data
        delete data['id']
        for (let key in data) {
          if (data[key] === null || data[key] === '') {
            delete data[key]
          }
        }
        this.detailData = data
        this.visible = true
      },
      handleDialogClose: function () {
        this.visible = false
      },
      back: function () {
        util.routerBack(this)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/record/show-delete-record.vue